import React from "react";

import { Typography } from "@mui/material";
import { formatDollar } from "../utilityFunctions";

const ProfitPercentage = ({ budgetData }) => {
    const summary = budgetData?.current_contract_summary;
    const projectedOverUnder = summary?.projected_over_under;
    const profitPercentage = summary?.profit_percentage;

    if (
        projectedOverUnder === undefined ||
        projectedOverUnder === null ||
        profitPercentage === undefined ||
        profitPercentage === null
    ) {
        return (
            <Typography style={{ textAlign: 'center' }} variant="body1" className="main-key-project-info-body">
                --
            </Typography>
        );
    }

    return (
        <Typography style={{ textAlign: 'center' }} variant="body1" className="main-key-project-info-body">
            {`${formatDollar(projectedOverUnder)} [${profitPercentage.toFixed(2)}%]`}
        </Typography>
    );
};

export default ProfitPercentage;
